import { oc } from "@orpc/contract";
import { z } from "zod";

const ShippingDocumentWithLineItemsSchema = z
  .object({
    lineItems: z.array(z.any()),
  })
  .passthrough();

export const shippingDocumentsContracts = {
  byPurchaseOrder: oc
    .input(
      z.object({
        purchaseOrderId: z.uuid(),
      }),
    )
    .output(z.array(ShippingDocumentWithLineItemsSchema))
    .route({
      method: "GET",
      path: "/supply-chain-management/shipping-documents/by-purchase-order/{purchaseOrderId}",
    }),
} as const;

export type ShippingDocumentWithLineItems = z.infer<
  typeof ShippingDocumentWithLineItemsSchema
>;
